import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

export default function updateValueAtPath<
  InputType = any,
  ReturnType = InputType
>({
  base,
  path,
  updatedValues,
}: {
  base: InputType;
  path?: string;
  updatedValues: any;
}): ReturnType {
  return path
    ? set(cloneDeep(base as any), path, updatedValues)
    : { ...base, ...updatedValues };
}
